import { processSightings, Sighting } from "anqr-js";
import { getQueryParam } from "./utils";
import ordinal from "ordinal";

export default () => ({
  id: getQueryParam("id"),
  nickname: localStorage.getItem("nickname") || "",
  editing: !localStorage.getItem("nickname"), // Start in edit mode if no nickname
  position: "?st",
  score: Number.parseInt(localStorage.getItem("score") || "0"),
  ducks: Number.parseInt(localStorage.getItem("ducks") || "0"),
  response: "",
  alreadyFound: false,
  checkedOthers: false,
  reported: false,
  reporting: false,
  cannotSave() {
    return this.reported || this.alreadyFound || !this.nickname || this.editing;
  },
  userId: localStorage.getItem("userId") || crypto.randomUUID() || "unknown",

  async init() {
    localStorage.setItem("userId", this.userId);
    if (this.id) {
      if (document.location.hostname == "localhost") {
        this.fakeReport();
        return;
      }
      this.initReport(this.id);
    }
  },
  async fakeReport() {
    setTimeout(() => {
      this.position = ordinal(Math.round(Math.random() * 100) + 10);
      this.alreadyFound = Math.random() > 0.7;
      this.checkedOthers = true;
      if (!this.alreadyFound) {
        setTimeout(() => {
          this.reporting = true;
          this.reported = true;
        }, 600);
        setTimeout(() => {
          this.response = "sighting created";
          this.reporting = false;
        }, 1200);
      }
    }, 200);
  },
  async initReport(duck_id: string) {
    const others = await processSightings(
      (acc, sighting) => acc.add(sighting.user_id),
      new Set<string>(),
      {
        lambda:
          "https://gu2gplqrllxktghwcdrbpxhhce0tqlbx.lambda-url.eu-north-1.on.aws/",
        params: { duck_id },
      }
    );

    this.position = ordinal(others.size + 1);
    this.alreadyFound = others.has(this.userId);
    this.checkedOthers = true;
  },

  saveNickname() {
    if (this.nickname.trim()) {
      localStorage.setItem("nickname", this.nickname.trim());
      this.editing = false;
    }
  },
  report() {
    this.reporting = true;
    fetch(
      "https://7qqeuzwht3w44weoj7tmw73fyq0xndgj.lambda-url.eu-north-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          duck_id: this.id,
          user_id: this.userId,
          nickname: this.nickname,
        }),
      }
    )
      .then((response) => response.json())
      .then(({ message }) => {
        this.reporting = false;
        this.reported = true;
        this.response = message;
        this.score += this.position == "1st" ? 10 : 5;
        localStorage.setItem("score", this.score.toString());
        this.ducks += 1;
        localStorage.setItem("ducks", this.ducks.toString());
      })
      .catch((error) => alert("Error sending report." + error));
  },
});
